// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"01946879","294":"885ee34a","413":"d932c6a6","431":"0dbec7b8","447":"84768543","502":"a831c6c0","567":"b8613456","637":"34b4a466","664":"091792fd","879":"ec65f112"}[chunkId] + ".chunk.js";
};